import {
    AccessTimeOutlined,
    ArrowBackIosNewOutlined,
    InfoOutlined,
    PersonOutlineOutlined,
} from '@mui/icons-material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

import deliverImg from '../../../assets/delivery-icon.svg';
import invoiceIcon from '../../../assets/invoice-w.png';
// import locationImg from '../../../assets/locationicon.svg';
// import loyaltyIcon from '../../../assets/loyalityicon.svg';
import { addItemToCart } from '../api/addToCart';
import { getCart } from '../api/getCart';
import { getCategories, getLocationCategoriesWithProducts } from '../api/getCategories';
import { getProduct } from '../api/getProduct';
import { getProductsByCategory } from '../api/getProducts';
import { getPromiseTime } from '../api/getPromiseTime';
import { Category, Product } from '../type';
import { handleDateFormat, handleOnError } from '@/utils/commonHelperFunc';
import { svgPaths } from '@/components/Layout/SvgPaths';
import Delete from '@/components/Icons/Delete';
import { Spinner } from '@/components/Elements';
// import { axios } from '@/lib/axios';

const NewOrder1 = ({ closeDialog, isOrder, userData, selectedUserAction }:any) => {
    const [searchVal, setSearchVal] = useState<string>('');
    const [categories, setCategories] = useState<Category[]>([]);
    const [products, setProducts] = useState<Product[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isActive, setIsActive] = useState<string>('');
    const [cartList, setCartList] = useState<Product[]>([]);
    const [cartCharges, setCartCharges] = useState<{ delivery_fee: number; tax: number }>({});
    const [cartId, setCartId] = useState<null>(null);
    const [instructions, setInstructions] = useState<boolean>(false);
    const [timeSlots, setTimeSlots] = useState<string[]>([]);
    const [promiseTime, setPromiseTime] = useState<string | boolean>(false);
    const [storeinfo, setStoreinfo] = useState();

    const getLocationDetails = async () => {
        // const store = await axios.get(`/v1/get-location-by-id/${isOrder.store}`);
        // setStoreinfo(store.data);
        setStoreinfo({
            locations: {
                id: 2,
                location_name: 'S. Grand',
                location_description: '',
                location_address_1: '3107 S. GRAND',
                location_address_2: '',
                location_city: 'ST. LOUIS',
                location_state: 'MO',
                location_zip: '63118',
                location_country: 'USA',
                location_timezone: -5,
                location_phone: '314-396-8683',
                location_fax: '',
                location_tax_rate: 7.5,
                location_service_fee: 0,
                location_is_takeout: 1,
                location_takeout_buffer: 30,
                location_is_delivery: 1,
                location_delivery_buffer: 60,
                location_gratuity: '15',
                location_is_auto_gratuity: 0,
                location_auto_gratuity: 0,
                location_is_shown: 1,
                location_active: 1,
                location_mode: null,
            },
            timeHours: [
                {
                    id: 1,
                    location_id: 2,
                    is_sunday_holiday: 0,
                    sunday_open: '04:00:00',
                    sunday_close: '04:00:00',
                    holiday_sunday_open: '04:00:00',
                    holiday_sunday_close: '10:30:00',
                    is_monday_holiday: 0,
                    monday_open: '10:30:00',
                    monday_close: '10:30:00',
                    holiday_monday_open: '08:30:00',
                    holiday_monday_close: '23:00:00',
                    is_tuesday_holiday: 0,
                    tuesday_open: '09:30:00',
                    tuesday_close: '23:00:00',
                    holiday_tuesday_open: '08:30:00',
                    holiday_tuesday_close: '23:00:00',
                    is_wednesday_holiday: 0,
                    wednesday_open: '09:30:00',
                    wednesday_close: '23:00:00',
                    holiday_wednesday_open: '08:30:00',
                    holiday_wednesday_close: '23:00:00',
                    is_thursday_holiday: 0,
                    thursday_open: '09:30:00',
                    thursday_close: '23:00:00',
                    holiday_thursday_open: '08:30:00',
                    holiday_thursday_close: '23:00:00',
                    is_friday_holiday: 0,
                    friday_open: '09:30:00',
                    friday_close: '24:00:00',
                    holiday_friday_open: '09:30:00',
                    holiday_friday_close: '23:00:00',
                    is_saturday_holiday: 0,
                    saturday_open: '10:30:00',
                    saturday_close: '01:00:00',
                    holiday_saturday_open: '09:30:00',
                    holiday_saturday_close: '23:00:00',
                },
            ],
            assignedEmployee: [
                {
                    id: 24,
                    user_id: 24,
                    role_id: 3,
                    location_id: 2,
                    assigned: '2022-08-27T01:41:33.000Z',
                    active: 1,
                    role_name: 'Shift Manager',
                    tax_id: null,
                    tax_exempt: 0,
                    is_employee: 0,
                    is_ambassador: 0,
                    vip: 0,
                    notes: null,
                    first_name: 'Mukesh',
                    last_name: 'Kumar',
                    user_email: 'John1@gmail.com',
                    user_phone: '334-312-7851',
                    user_password:
                        '9407bb900e534280ae71e858c1f995bfe211174a8565ff718318271d6a913f4d6zLFrgnSA1MJelW3QCM4sA==cc4141152e58ba0ce2d5b401164266b6268ea9f9b1ebd608fdbc38e13f213e74',
                    user_creation_date: '2022-08-12T07:56:17.000Z',
                    user_last_active: '2022-08-12T07:56:17.000Z',
                    user_last_ordered: null,
                    user_birthday: '1966-11-16T18:30:00.000Z',
                    user_company: 'Airtel',
                    user_mobile_token: 'TOKENTOKEN',
                    default_perspective: 'user',
                    user_qr_code:
                        'ebdd99721f9ed02aefe26e6c6644898a9d78678216720d0520f87e6c94c97117rqhsMhNaA6nsZ8SNjYi6mw==176c7487b0b90388e82e9ce234606f0c4b1a9b1fe8c19f7c25ae71f742c4f50f',
                    user_active: 1,
                },
                {
                    id: 30,
                    user_id: 30,
                    role_id: 5,
                    location_id: 2,
                    assigned: '2022-08-30T06:00:00.000Z',
                    active: 1,
                    role_name: 'Crew Member',
                    tax_id: null,
                    tax_exempt: 0,
                    is_employee: 1,
                    is_ambassador: 0,
                    vip: 0,
                    notes: null,
                    first_name: 'Employee',
                    last_name: 'Test1',
                    user_email: 'emp1@gmail.com',
                    user_phone: '555-555-5555',
                    user_password:
                        '18cf862d336c2c24bf62cc9a9c316111048bacd5786d99e254364d4003b08c57zx1fg8CVKTfVUVbYQoOTNg==5fe4d52ba65bd3e58b191616ace4cac5ad20d2662c4e39e7ea9eea3fe9b75bbf',
                    user_creation_date: '2022-08-30T22:25:35.000Z',
                    user_last_active: '2022-08-30T22:25:35.000Z',
                    user_last_ordered: null,
                    user_birthday: '1985-08-05T18:30:00.000Z',
                    user_company: null,
                    user_mobile_token: 'TOKENTOKEN',
                    default_perspective: 'user',
                    user_qr_code:
                        '5fa2fbc4d599105c8c869730718ea67d258591ea2f89ac66b24ec5b9d85ee76fVT9sEPhNA1xCduwGDgdwmA==5d86ca377fee7ef9266a3449a98f96f4d19f5453a11b14b2a0b42fdcb7ed3923',
                    user_active: 1,
                },
                {
                    id: 35,
                    user_id: 35,
                    role_id: 5,
                    location_id: 2,
                    assigned: '2022-08-30T06:00:00.000Z',
                    active: 1,
                    role_name: 'Crew Member',
                    tax_id: null,
                    tax_exempt: 0,
                    is_employee: 1,
                    is_ambassador: 0,
                    vip: 0,
                    notes: null,
                    first_name: 'Employee',
                    last_name: 'Test6',
                    user_email: 'emp6@gmail.com',
                    user_phone: '555-555-5554',
                    user_password:
                        'd0b9b11fb440a54f362400541f54c3a5113e29b7ba01a83a7db6c97be1eefe41Q1+Zukq6xzRoRURXuKWAtQ==6ded8cc9556495fba2ac8bb2ec23d67adc057965e47b62aa04b587b3ae456f42',
                    user_creation_date: '2022-08-30T22:27:39.000Z',
                    user_last_active: '2022-08-30T22:27:39.000Z',
                    user_last_ordered: null,
                    user_birthday: '1985-08-05T18:30:00.000Z',
                    user_company: null,
                    user_mobile_token: 'TOKENTOKEN',
                    default_perspective: 'user',
                    user_qr_code:
                        '674e862abe3b3ab7bf03d75446f9dbc53cd967df1d929971089c214abf66ff354g0F28N/Mfp2OP0reqHSKQ==40eb6b388f156026b1429908ede008cbbbac7b0fbb9dd3f19536bae12a5df995',
                    user_active: 1,
                },
                {
                    id: 39,
                    user_id: 39,
                    role_id: 5,
                    location_id: 2,
                    assigned: '2022-08-30T06:00:00.000Z',
                    active: 1,
                    role_name: 'Crew Member',
                    tax_id: null,
                    tax_exempt: 0,
                    is_employee: 1,
                    is_ambassador: 0,
                    vip: 0,
                    notes: null,
                    first_name: 'Employee',
                    last_name: 'Test0',
                    user_email: 'emp0@gmail.com',
                    user_phone: '555-555-5559',
                    user_password:
                        '7beff6f25b6b315697153e8a710b36f66b2fa557b7fb61796e05ea9f713a2a1deCOK7TffyU/0KomcECd++Q==670c9f7656695df217c308350ab27128cbb550308c093fb0a95dfc7be42746a9',
                    user_creation_date: '2022-08-30T22:28:47.000Z',
                    user_last_active: '2022-08-30T22:28:47.000Z',
                    user_last_ordered: null,
                    user_birthday: '1985-08-05T18:30:00.000Z',
                    user_company: null,
                    user_mobile_token: 'TOKENTOKEN',
                    default_perspective: 'user',
                    user_qr_code:
                        'd7120c5464b47a6265943a56c0862d4e8bcb2a1c29ec195aca23cbce916742bdgGhcokW3OizFmGv2zKWhUw==07a3855d0d28afcd1031ad9bc8a0d300800729d11bde0ed0506fe6c2316a9cf3',
                    user_active: 1,
                },
            ],
        });
    };

    useEffect(() => {
        setIsLoading(true);
        getLocationDetails();
        const date = new Date();
        isOrder.order_type_id === '18'
            ? getLocationCategoriesWithProducts(isOrder.store).then((list) => {
                  setCategories(list);
                  setIsActive(list[0].category_name);
                  setProducts(list[0].products);
              })
            : getCategories().then((list) => {
                  setCategories(list);
                  setIsActive(list[2].category_name);
                  getProductsByCategory(list[2].id).then((list) => {
                      setProducts(list);
                  });
              });
        getPromiseTime(
            isOrder.store,
            isOrder.order_type_id,
            moment(date).format('YYYY-MM-DD')
        ).then((e) => setTimeSlots(e));
        setIsLoading(false);
    }, []);

    if (isLoading) {
        return (
            <div className="w-full h-48 flex justify-center items-center">
                <Spinner size="lg" />
            </div>
        );
    }
    const handleCategoryChange = (category: any) => {
        setIsLoading(true);
        setIsActive(category.category_name);
        isOrder.order_type_id === '18'
            ? setProducts(category.products)
            : getProductsByCategory(category.id).then((list) => {
                  setProducts(list);
              });
        setIsLoading(false);
    };

    const filteredProducts = products?.filter((product) => {
        return product?.product_name?.toLowerCase()?.includes(searchVal.toLowerCase());
    });
    const filteredCategories = categories?.filter((category) =>
        category.category_name === 'Hero' || category.category_name === 'Recommended'
            ? null
            : category
    );

    const addToCart = () => {
        const {
            id,
            menu_item_quantity,
            menu_item_instructions,
            modifiers,
            product_type_id,
            ...remain
        }:any = selectedProduct;

        cartList.find((item) => item?.id === selectedProduct?.id)
            ? null
            : (addItemToCart(
                  {
                      location_id: parseInt(isOrder.store),
                      order_type_id: isOrder.order_type_id,
                      mode_id: 2,
                      promised_time: `${new Date().toISOString().split('T')[0]}`,
                      menu_id: 2,
                      menu_item_quantity,
                      menu_item_instructions,
                      user_id: 74,
                      menu_item_person:
                          userData.first_name != null
                              ? userData.first_name + ' ' + userData.last_name
                              : userData.corporate_name,
                      corporate_id: userData.corporate_name != null ? userData.id : 0,
                      menu_item_modifiers: [
                          {
                              product_id: id,
                              id,
                              is_required: 1,
                              select_min: 1,
                              select_max: 1,
                              active: 1,
                              pmg_active: 1,
                              modification_text: 'frontend test',
                              //  options: modifiers,
                              options: [
                                  {
                                      id: 1,
                                      mod_group_id: 1,
                                      option_name: 'Birthday Balloon',
                                      option_price: 0,
                                      active: 1,
                                  },
                              ],
                          },
                      ],
                  },
                  cartId
              )
                  .then((res) => {
                      setCartId(res);
                      getCart(res).then((e) => {
                          setCartCharges(e.cart.charges);
                      });
                  })
                  .catch((err) => console.log(err.message)),
              setCartList([...cartList, selectedProduct]));
        setSelectedProduct(false);
    };

    const handleSelected = (product) => {
        getProduct(product.id, product.product_category_id).then((res) => {
            setSelectedProduct({ ...res, menu_item_quantity: 1 });
        });
    };

    const removeProduct = (id) => {
        setCartList(cartList.filter((product) => product.id !== id));
    };

    return storeinfo == null ? (
        <>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="h-full w-full flex items-center justify-center">
                        <Spinner size="xl" />
                    </div>
                </div>
            </div>
        </>
    ) : (
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title" id="neworder2ModalLabel">
                    New Order
                    {/*#224589*/}
                </h5>
                <button type="button" className="btn-close" onClick={() => closeDialog()}></button>
            </div>
            <div className="modal-body">
                <div className="info-header location-edit pt-0 mb-0">
                    <div className="left-info">
                        <p className="d-flex">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={svgPaths['Locations'].width}
                                height={svgPaths['Locations'].height}
                                viewBox={svgPaths['Locations'].viewBox}
                                fill="none"
                            >
                                <path d={svgPaths['Locations'].path} fill="#7AAD37" />
                            </svg>
                            <strong>{storeinfo.location_name}</strong> /{' '}
                            {storeinfo.location_address_1}, {storeinfo.location_city},{' '}
                            {storeinfo.location_state} {storeinfo.location_zip}
                        </p>
                    </div>
                    <div className="right-info">
                        <div className="order-left-head">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="flexRadioDefault"
                                    id="flexRadioDefault1"
                                    defaultChecked={isOrder.order_type_id === '17'}
                                    disabled
                                />
                                <label className="form-check-label" htmlFor="flexRadioDefault1">
                                    Pickup
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="flexRadioDefault"
                                    id="flexRadioDefault2"
                                    defaultChecked={isOrder.order_type_id === '18'}
                                    disabled
                                />
                                <label className="form-check-label" htmlFor="flexRadioDefault2">
                                    Delivery
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row new-order1">
                    <div className="col-12 col-md-8 new-order-leftcol">
                        <div className="accordion accordion-flush" id="accordionorder">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="flush-headingOne">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseOne"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseOne"
                                    >
                                        <p className="box-cookie-tx">
                                            <span>
                                                <PersonOutlineOutlined className="pColor" />
                                                <strong>
                                                    {userData.corporate_name ||
                                                        (userData.first_name &&
                                                            userData.last_name) ||
                                                        '-'}
                                                </strong>
                                            </span>
                                        </p>
                                    </button>
                                </h2>
                                <div
                                    id="flush-collapseOne"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingOne"
                                    data-bs-parent="#accordionorder"
                                >
                                    <div className="accordion-body">
                                        <div className="jacob-info">
                                            <ul className="corporation-list">
                                                <li>
                                                    <strong>
                                                        <svg
                                                            width="20"
                                                            height="16"
                                                            viewBox="0 0 20 16"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M3.33203 3.83333C3.33203 4.4926 3.52753 5.13707 3.8938 5.68523C4.26007 6.2334 4.78067 6.66064 5.38975 6.91293C5.99884 7.16522 6.66906 7.23124 7.31567 7.10262C7.96227 6.974 8.55621 6.65653 9.02239 6.19036C9.48856 5.72418 9.80603 5.13024 9.93465 4.48363C10.0633 3.83703 9.99726 3.16681 9.74496 2.55772C9.49267 1.94863 9.06543 1.42804 8.51727 1.06177C7.9691 0.695497 7.32464 0.5 6.66536 0.5C5.78131 0.5 4.93346 0.851189 4.30834 1.47631C3.68322 2.10143 3.33203 2.94928 3.33203 3.83333ZM8.33203 3.83333C8.33203 4.16297 8.23428 4.4852 8.05115 4.75928C7.86801 5.03337 7.60771 5.24699 7.30317 5.37313C6.99863 5.49928 6.66352 5.53228 6.34021 5.46798C6.01691 5.40367 5.71994 5.24493 5.48685 5.01184C5.25377 4.77876 5.09503 4.48179 5.03072 4.15848C4.96641 3.83518 4.99942 3.50007 5.12557 3.19553C5.25171 2.89098 5.46533 2.63069 5.73941 2.44755C6.0135 2.26442 6.33573 2.16667 6.66536 2.16667C7.10739 2.16667 7.53132 2.34226 7.84388 2.65482C8.15644 2.96738 8.33203 3.39131 8.33203 3.83333ZM1.66536 15.5H11.6654C11.8864 15.5 12.0983 15.4122 12.2546 15.2559C12.4109 15.0996 12.4987 14.8877 12.4987 14.6667V12.1667C12.4987 11.2826 12.1475 10.4348 11.5224 9.80964C10.8973 9.18452 10.0494 8.83333 9.16537 8.83333H4.16536C3.28131 8.83333 2.43346 9.18452 1.80834 9.80964C1.18322 10.4348 0.832031 11.2826 0.832031 12.1667V14.6667C0.832031 14.8877 0.919829 15.0996 1.07611 15.2559C1.23239 15.4122 1.44435 15.5 1.66536 15.5ZM2.4987 12.1667C2.4987 11.7246 2.67429 11.3007 2.98685 10.9882C3.29941 10.6756 3.72334 10.5 4.16536 10.5H9.16537C9.60739 10.5 10.0313 10.6756 10.3439 10.9882C10.6564 11.3007 10.832 11.7246 10.832 12.1667V13.8333H2.4987V12.1667ZM19.1654 1.33333C19.1654 1.55435 19.0776 1.76631 18.9213 1.92259C18.765 2.07887 18.553 2.16667 18.332 2.16667H13.332C13.111 2.16667 12.8991 2.07887 12.7428 1.92259C12.5865 1.76631 12.4987 1.55435 12.4987 1.33333C12.4987 1.11232 12.5865 0.900358 12.7428 0.744078C12.8991 0.587797 13.111 0.5 13.332 0.5H18.332C18.553 0.5 18.765 0.587797 18.9213 0.744078C19.0776 0.900358 19.1654 1.11232 19.1654 1.33333ZM19.1654 4.66667C19.1654 4.88768 19.0776 5.09964 18.9213 5.25592C18.765 5.4122 18.553 5.5 18.332 5.5H13.332C13.111 5.5 12.8991 5.4122 12.7428 5.25592C12.5865 5.09964 12.4987 4.88768 12.4987 4.66667C12.4987 4.44565 12.5865 4.23369 12.7428 4.07741C12.8991 3.92113 13.111 3.83333 13.332 3.83333H18.332C18.553 3.83333 18.765 3.92113 18.9213 4.07741C19.0776 4.23369 19.1654 4.44565 19.1654 4.66667ZM19.1654 8C19.1654 8.22101 19.0776 8.43297 18.9213 8.58926C18.765 8.74554 18.553 8.83333 18.332 8.83333H13.332C13.111 8.83333 12.8991 8.74554 12.7428 8.58926C12.5865 8.43297 12.4987 8.22101 12.4987 8C12.4987 7.77899 12.5865 7.56702 12.7428 7.41074C12.8991 7.25446 13.111 7.16667 13.332 7.16667H18.332C18.553 7.16667 18.765 7.25446 18.9213 7.41074C19.0776 7.56702 19.1654 7.77899 19.1654 8Z"
                                                                fill="#7AAD37"
                                                            />
                                                        </svg>
                                                        Information
                                                    </strong>
                                                </li>
                                                {userData.user_birthday ? (
                                                    <>
                                                        <li>
                                                            <strong>Birthday: </strong>
                                                            <span>
                                                                {handleDateFormat(
                                                                    userData.user_birthday
                                                                ) || '-'}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <strong>Company: </strong>
                                                            <span>
                                                                {userData.user_company || '-'}
                                                            </span>
                                                        </li>
                                                    </>
                                                ) : null}
                                                <li>
                                                    <strong>Email: </strong>
                                                    <span>
                                                        {userData.corporate_email ||
                                                            userData.user_email ||
                                                            '-'}
                                                    </span>
                                                </li>
                                                <li>
                                                    <strong>Phone: </strong>
                                                    <span>
                                                        {userData.corporate_phone ||
                                                            userData.user_phone ||
                                                            '-'}
                                                    </span>
                                                </li>
                                                <li>
                                                    <strong>Created: </strong>
                                                    <span>
                                                        {handleDateFormat(
                                                            userData.corporate_creation_date
                                                        ) ||
                                                            handleDateFormat(
                                                                userData.user_creation_date
                                                            ) ||
                                                            '-'}
                                                    </span>
                                                </li>
                                            </ul>
                                            {isOrder.address ? (
                                                <ul className="corporation-list">
                                                    <li>
                                                        <strong>
                                                            <img
                                                                src={deliverImg}
                                                                alt="deliverImg"
                                                            />
                                                            Delivery Address
                                                        </strong>
                                                    </li>
                                                    <li>
                                                        <span>{isOrder.address}</span>
                                                    </li>
                                                </ul>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="order-new-search pb-4 pt-4 d-flex justify-content-between align-items-center">
                            <p className="mb-0">
                                <strong>Products</strong>
                            </p>
                            <div
                                className="input-group search make-search"
                                style={{ width: 'max-content' }}
                            >
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search"
                                    style={{ margin: '0 !important' }}
                                    value={searchVal}
                                    onChange={(e) => setSearchVal(e.target.value)}
                                />
                                <div className="input-group-append">
                                    <span className="input-group-text">
                                        <i className="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="order-list-tabs">
                            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                {filteredCategories?.map((category) => {
                                    const { id, category_name } = category;
                                    return (
                                        <li key={id} className="nav-item" role="presentation">
                                            <button
                                                className={`nav-link ${
                                                    isActive === category_name && 'active'
                                                }`}
                                                type="button"
                                                role="tab"
                                                onClick={() =>
                                                    isActive !== category_name
                                                        ? handleCategoryChange(category)
                                                        : null
                                                }
                                            >
                                                {category_name}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div
                                    className="tab-pane fade show active"
                                    id="pills-cookie"
                                    role="tabpanel"
                                    aria-labelledby="pills-cookie-tab"
                                >
                                    <div className="row">
                                        {selectedProduct ? (
                                            <div
                                                className="tab-pane fade show active"
                                                id="pills-cookie"
                                                role="tabpanel"
                                                aria-labelledby="pills-cookie-tab"
                                            >
                                                <div className="row choose-back align-items-center">
                                                    <div className="col-12 col-md-5">
                                                        <div
                                                            className="back-btn d-flex align-items-center"
                                                            onClick={() => setSelectedProduct(null)}
                                                        >
                                                            <a className="back-anc" href="#">
                                                                <div className="back-bt">
                                                                    <ArrowBackIosNewOutlined />
                                                                </div>
                                                            </a>
                                                            <span style={{ marginLeft: '10px' }}>
                                                                Back
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-7">
                                                        <div className="order-increment d-flex align-items-center justify-content-end">
                                                            <div className="inrement-lft d-flex align-items-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn add-order"
                                                                    onClick={() => {
                                                                        selectedProduct.menu_item_quantity >
                                                                        1
                                                                            ? setSelectedProduct({
                                                                                  ...selectedProduct,
                                                                                  menu_item_quantity:
                                                                                      selectedProduct.menu_item_quantity -
                                                                                      1,
                                                                              })
                                                                            : null;
                                                                    }}
                                                                >
                                                                    -
                                                                </button>
                                                                <p className="mb-0">
                                                                    {
                                                                        selectedProduct.menu_item_quantity
                                                                    }
                                                                </p>
                                                                <button
                                                                    type="button"
                                                                    className="btn add-order"
                                                                    onClick={() => {
                                                                        setSelectedProduct({
                                                                            ...selectedProduct,
                                                                            menu_item_quantity:
                                                                                selectedProduct.menu_item_quantity +
                                                                                1,
                                                                        });
                                                                    }}
                                                                >
                                                                    +
                                                                </button>
                                                            </div>

                                                            <div className="add-order">
                                                                <button
                                                                    type="button"
                                                                    className="btn add-icon-btn"
                                                                    onClick={() => addToCart()}
                                                                >
                                                                    Add To Order
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row choose-cookie">
                                                    <div className="col-12 col-md-6">
                                                        <div className="new-ordr d-flex align-items-center">
                                                            <div className="ordr-icn">
                                                                <img
                                                                    src={
                                                                        selectedProduct.product_image
                                                                    }
                                                                    alt="pImg"
                                                                    onError={handleOnError}
                                                                />
                                                            </div>
                                                            <div className="order-details">
                                                                <p className="mb-0">
                                                                    <strong>
                                                                        {
                                                                            selectedProduct.product_name
                                                                        }
                                                                    </strong>
                                                                </p>
                                                                <p className="mb-0 dark-tx">
                                                                    ${selectedProduct.price}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <p className="text-right mb-0">
                                                            Choose 6 cookies /
                                                            <strong>3 Left</strong>
                                                        </p>
                                                        <p className="sm-tx text-right mb-0">
                                                            {selectedProduct.product_description}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    {selectedProduct?.modifiers.map(
                                                        ({ id, modification_text }) => (
                                                            <div
                                                                className="col-12 col-md-6"
                                                                key={id}
                                                            >
                                                                <div className="product-check-box">
                                                                    <div className="pr-left-ic">
                                                                        <label
                                                                            htmlFor={`modifiers${id}`}
                                                                            className="flex"
                                                                            style={{
                                                                                margin: '0',
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    selectedProduct.product_image
                                                                                }
                                                                                alt="pImg"
                                                                                onError={
                                                                                    handleOnError
                                                                                }
                                                                            />
                                                                            {modification_text}
                                                                        </label>
                                                                    </div>
                                                                    <div className="pr-right-ic">
                                                                        <div className="checkboxes">
                                                                            <div className="all-bx">
                                                                                <label
                                                                                    className="checkbox"
                                                                                    style={{
                                                                                        margin: '0',
                                                                                    }}
                                                                                >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={`modifiers${id}`}
                                                                                        name={`modifiers${id}`}
                                                                                        value={`modifiers${id}`}
                                                                                    />
                                                                                    <span></span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                                <div className="options-avail d-flex justify-content-between">
                                                    <h5>Optional</h5>
                                                    <div className="options-check">
                                                        <div className="checkboxes d-flex">
                                                            <div
                                                                className="all-bx"
                                                                style={{ paddingLeft: '10px' }}
                                                            >
                                                                <label className="checkbox">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="Instructions"
                                                                        name="Special Instructions"
                                                                        defaultChecked={
                                                                            instructions
                                                                        }
                                                                        onChange={(e) =>
                                                                            setInstructions(
                                                                                e.target.checked
                                                                            )
                                                                        }
                                                                    />
                                                                    <span>
                                                                        Special Instructions
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {instructions ? (
                                                    <div className="row">
                                                        <div className="col-12 col-md-6">
                                                            <label className="control-label">
                                                                Your Instructions
                                                            </label>
                                                            <div className="form-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="street"
                                                                    placeholder="Please, wrap in red paper"
                                                                    onChange={(e) =>
                                                                        setSelectedProduct({
                                                                            ...selectedProduct,
                                                                            menu_item_instructions:
                                                                                e.target.value,
                                                                        })
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        ) : products.length === 0 ? (
                                            <h2>No products avialable</h2>
                                        ) : (
                                            filteredProducts?.map((product) => (
                                                <div
                                                    className="col-12 col-md-4"
                                                    key={product?.id}
                                                    onClick={(e) => handleSelected(product)}
                                                >
                                                    <div className="card">
                                                        <a href="#">
                                                            <img
                                                                className="card-img-top"
                                                                alt="cookie"
                                                                src={product.product_image}
                                                                onError={handleOnError}
                                                            />
                                                        </a>
                                                        <div className="card-body">
                                                            <p className="card-text price">
                                                                ${product?.price}
                                                            </p>
                                                            <h5
                                                                className="card-title"
                                                                style={{
                                                                    color: '#111111',
                                                                    fontWeight: '600',
                                                                    fontSize: '16px',
                                                                }}
                                                            >
                                                                {product?.product_name}
                                                            </h5>
                                                            <p
                                                                className="card-text"
                                                                style={{
                                                                    color: 'rgba(17, 17, 17, 0.48)',
                                                                    fontSize: '14px',
                                                                }}
                                                            >
                                                                {product?.product_description}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 order-col-rgt">
                        <div className="info-header location-edit">
                            <div className="left-info">
                                <p className="d-flex">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={svgPaths['Orders'].width}
                                        height={svgPaths['Orders'].height}
                                        viewBox={svgPaths['Orders'].viewBox}
                                        fill="none"
                                    >
                                        <path d={svgPaths['Orders'].path} fill="#7AAD37" />
                                    </svg>
                                    <strong>Order</strong>
                                </p>
                            </div>
                        </div>
                        {cartList.length > 0 ? (
                            <>
                                {cartList?.map(
                                    ({
                                        id,
                                        product_name,
                                        price,
                                        menu_item_instructions,
                                        menu_item_quantity,
                                        product_image,
                                    }) => (
                                        <div className="new-products-list" key={id}>
                                            <div className="row">
                                                <div className="col-12 col-md-8">
                                                    <div className="new-ordr d-flex align-items-center">
                                                        <div className="ordr-icn">
                                                            <img
                                                                src={product_image}
                                                                alt="pImg"
                                                                onError={handleOnError}
                                                            />
                                                        </div>
                                                        <div className="order-details">
                                                            <p className="mb-0">
                                                                <strong>{product_name}</strong>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4">
                                                    <div className="order-quantity d-flex justify-content-between align-items-center h-100">
                                                        <p className="mb-0">
                                                            {menu_item_quantity} x
                                                            <strong> ${price}</strong>
                                                        </p>
                                                        <a
                                                            onClick={() => removeProduct(id)}
                                                            href="#"
                                                        >
                                                            <Delete />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            {menu_item_instructions ? (
                                                <p className="instructions f-14 pt-2">
                                                    <InfoOutlined className="pColor" /> Special
                                                    instructions:
                                                    <strong>{menu_item_instructions}</strong>
                                                </p>
                                            ) : null}
                                        </div>
                                    )
                                )}
                                <div className="checkboxes pt-2">
                                    <div className="all-bx">
                                        <label className="checkbox">
                                            <input
                                                type="checkbox"
                                                id="reward"
                                                name="reward"
                                                value="reward"
                                            />
                                            <span> Add discount</span>
                                        </label>
                                    </div>
                                </div>
                                <ul className="instruction-listing">
                                    {/*<li>
                                        <span style={{ display: 'flex', gap: '0.3rem' }}>
                                            <img src={loyaltyIcon} /> Points
                                        </span>
                                        <span className="dark-tx"></span>
                                    </li>*/}
                                    <li>
                                        <span> Sub-total</span>
                                        <span className="dark-tx">$</span>
                                    </li>
                                    <li>
                                        <span> Delivery fee</span>
                                        <span className="dark-tx">
                                            ${cartCharges?.delivery_fee}
                                        </span>
                                    </li>
                                    <li>
                                        <span> Tax</span>
                                        <span className="dark-tx">${cartCharges?.tax}</span>
                                    </li>
                                    <li>
                                        <strong>Total</strong>
                                        <span className="dark-tx">
                                            <strong>$</strong>
                                        </span>
                                    </li>
                                </ul>
                                <div className="row timer-row flex align-items-center">
                                    <div className="col-12 col-md-6">
                                        <div className="time-wrap">
                                            <h6>
                                                <AccessTimeOutlined className="pColor" /> Promised
                                                Time
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group">
                                            <select
                                                className="form-control"
                                                name="status"
                                                required
                                                onChange={(e) => setPromiseTime(e.target.value)}
                                            >
                                                <option value="">Select or Type</option>
                                                {timeSlots.map((value: string) => (
                                                    <option key={value} value={value}>
                                                        {value}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <hr className="mb-3" />
                                <div className="instuct-btn">
                                    <button
                                        type="button"
                                        className="btn add-icon-btn flex justify-center"
                                        onClick={() =>
                                            selectedUserAction({
                                                action: 'add-invoice',
                                                data: {
                                                    ...userData,
                                                    ...cartCharges,
                                                    promiseTime: `${
                                                        new Date().toISOString().split('T')[0]
                                                    } ${promiseTime}`,
                                                },
                                            })
                                        }
                                        disabled={!promiseTime}
                                    >
                                        <img src={invoiceIcon} alt="invoice" /> Send Invoice
                                    </button>
                                </div>
                            </>
                        ) : (
                            <div className="col-12 col-md-4 w-full">
                                <div className="new-products">
                                    <div className="pr-icon">
                                        <svg
                                            width="19"
                                            height="22"
                                            viewBox="0 0 19 22"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M1.5 22H17.5C17.7652 22 18.0196 21.8946 18.2071 21.7071C18.3946 21.5196 18.5 21.2652 18.5 21V5C18.5 4.73478 18.3946 4.48043 18.2071 4.29289C18.0196 4.10536 17.7652 4 17.5 4H1.5C1.23478 4 0.98043 4.10536 0.792893 4.29289C0.605357 4.48043 0.5 4.73478 0.5 5V21C0.5 21.2652 0.605357 21.5196 0.792893 21.7071C0.98043 21.8946 1.23478 22 1.5 22ZM2.5 6H16.5V20H2.5V6ZM15.5 0C15.7652 0 16.0196 0.105357 16.2071 0.292893C16.3946 0.48043 16.5 0.734784 16.5 1C16.5 1.26522 16.3946 1.51957 16.2071 1.70711C16.0196 1.89464 15.7652 2 15.5 2H3.5C3.23478 2 2.98043 1.89464 2.79289 1.70711C2.60536 1.51957 2.5 1.26522 2.5 1C2.5 0.734784 2.60536 0.48043 2.79289 0.292893C2.98043 0.105357 3.23478 0 3.5 0H15.5ZM13.5 9V11C13.5 11.2652 13.3946 11.5196 13.2071 11.7071C13.0196 11.8946 12.7652 12 12.5 12H6.5C6.23478 12 5.98043 11.8946 5.79289 11.7071C5.60536 11.5196 5.5 11.2652 5.5 11V9C5.5 8.73478 5.60536 8.48043 5.79289 8.29289C5.98043 8.10536 6.23478 8 6.5 8C6.76522 8 7.01957 8.10536 7.20711 8.29289C7.39464 8.48043 7.5 8.73478 7.5 9V10H11.5V9C11.5 8.73478 11.6054 8.48043 11.7929 8.29289C11.9804 8.10536 12.2348 8 12.5 8C12.7652 8 13.0196 8.10536 13.2071 8.29289C13.3946 8.48043 13.5 8.73478 13.5 9Z"
                                                fill="#7AAD37"
                                            />
                                        </svg>
                                    </div>
                                    <h5 className="text-center font-bold">There are no products</h5>
                                    <p className="text-center">
                                        You currently do not have any items. Please add items to
                                        your order
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewOrder1;
